export default __webpack_public_path__ + "locales/sr-Cyrl-RS/ChangeUserTypeDialog.json?hash=5cbe6c1699815199903af1f3b842be57";